import React from 'react'
import { withIcon } from '../../withIcon'

function InstagramIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M8 4.625C6.13604 4.625 4.625 6.13604 4.625 8V16C4.625 17.864 6.13604 19.375 8 19.375H16C17.864 19.375 19.375 17.864 19.375 16V8C19.375 6.13604 17.864 4.625 16 4.625H8ZM3.375 8C3.375 5.44568 5.44568 3.375 8 3.375H16C18.5543 3.375 20.625 5.44568 20.625 8V16C20.625 18.5543 18.5543 20.625 16 20.625H8C5.44568 20.625 3.375 18.5543 3.375 16V8ZM12 9.625C10.6883 9.625 9.625 10.6883 9.625 12C9.625 13.3117 10.6883 14.375 12 14.375C13.3117 14.375 14.375 13.3117 14.375 12C14.375 10.6883 13.3117 9.625 12 9.625ZM8.375 12C8.375 9.99797 9.99797 8.375 12 8.375C14.002 8.375 15.625 9.99797 15.625 12C15.625 14.002 14.002 15.625 12 15.625C9.99797 15.625 8.375 14.002 8.375 12Z" fill={color}/>
    </svg>
  )
}

export default withIcon(InstagramIcon)
